import { render, staticRenderFns } from "./ReviewScoreIcon.vue?vue&type=template&id=f922159e&scoped=true&"
import script from "./ReviewScoreIcon.vue?vue&type=script&lang=js&"
export * from "./ReviewScoreIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReviewScoreIcon.vue?vue&type=style&index=0&id=f922159e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f922159e",
  null
  
)

export default component.exports